export default "__VITE_ASSET__DPm0krMh__"